// hooks/useRealtimeSync.js
import { useEffect, useCallback, useRef } from "react";
import websocketService from "../services/websocketService";

export const useRealtimeSync = (config) => {
  const { events = [], onUpdate, onError, enabled = true } = config;

  const unsubscribeRefs = useRef([]);

  const handleUpdate = useCallback(
    (data) => {
      try {
        if (onUpdate) {
          onUpdate(data);
        }
      } catch (error) {
        console.error("Error handling real-time update:", error);
        if (onError) {
          onError(error);
        }
      }
    },
    [onUpdate, onError],
  );

  useEffect(() => {
    if (!enabled) {
      return;
    }

    // Connect WebSocket
    websocketService.connect();

    // Subscribe to events
    events.forEach((event) => {
      const unsubscribe = websocketService.on(event, handleUpdate);
      unsubscribeRefs.current.push(unsubscribe);
    });

    // Cleanup
    return () => {
      unsubscribeRefs.current.forEach((unsubscribe) => unsubscribe());
      unsubscribeRefs.current = [];
    };
  }, [events, enabled, handleUpdate]);

  return {
    isConnected: websocketService.isConnected(),
  };
};
